<template>
  <div v-loading="loading" element-loading-text="加载中..." class="app-container" />
</template>

<script>
export default {
  name: "AccountStatement",
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped>
</style>
